import { FC, ReactNode } from 'react';

import IconButton from './IconButton';

export type NoticeVariant = 'error' | 'success' | 'warning' | 'info';

export type NoticeProps = {
  variant?: NoticeVariant;
  children: ReactNode;
  /** Shows a dismiss control when provided. */
  onDismiss?: () => void;
  /** Placement only: the tint, frame, padding and type are the notice's. */
  className?: string;
};

/**
 * The one inline notice.
 *
 * It replaces the separate error, notice and warning rules the pages each
 * carried: one tinted surface with an accent border, one type role and one
 * dismiss layout. Error is announced as an alert, the rest as a status.
 */
const Notice: FC<NoticeProps> = ({ variant = 'info', children, onDismiss, className }) => (
  <div
    className={['ui-notice', 'ui-notice--' + variant, className].filter(Boolean).join(' ')}
    role={variant === 'error' ? 'alert' : 'status'}
  >
    <span className="ui-notice-text">{children}</span>
    {onDismiss && (
      <IconButton label="Dismiss" size="sm" onClick={onDismiss}>
        ×
      </IconButton>
    )}
  </div>
);

export default Notice;
